import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Footer from '../components/Footer';
import Header from '../components/Header';
import MobileBottomNav from '../components/MobileBottomNav';

import { AdminUserProvider } from '../utils/hook/AdminUserContext';
import { ProvideAxios } from '../utils/hook/useAxios';
import { FavoritesProvider } from '../utils/hook/useFavorites';
import { UserProvider } from '../utils/hook/UserContext';
import { SelectionProvider } from '../utils/hook/useSelection';

import AppRoutes from './routes';
import SocketManager from './SocketManager';

function App() {
  return (
    <ProvideAxios>
      <UserProvider>
        <AdminUserProvider>
          <FavoritesProvider>
            <SelectionProvider>
              <BrowserRouter>
                <SocketManager />

                <Header />

                <ToastContainer />

                <AppRoutes />

                <div className="d-none d-md-block">
                  <Footer />
                </div>

                <MobileBottomNav />
              </BrowserRouter>
            </SelectionProvider>
          </FavoritesProvider>
        </AdminUserProvider>
      </UserProvider>
    </ProvideAxios>
  );
}

export default App;
